import { useEffect } from 'react'

import { useDataLayer } from '~/hooks/useDataLayer/useDataLayer'
import { useGetMe } from '~/pages/hooks/useGetMe'

export function useTrackClickEvent(): void {
  const { push } = useDataLayer()
  const { memberId, organizationId, organizationName } = useGetMe()

  useEffect(() => {
    const abortController = new AbortController()

    function handleClick(event: MouseEvent): void {
      const target = event.target as HTMLElement

      const eventTarget = target.closest('[data-gtm-button]') as HTMLElement
      if (eventTarget == null) {
        return
      }

      const buttonId = eventTarget.getAttribute('data-gtm-button')

      if (buttonId == null) {
        return
      }

      const payload = {}
      // set the data-gtm-* attributes as payload
      for (const attribute of eventTarget.attributes) {
        if (attribute.name === 'data-gtm-button') {
          continue
        }

        if (attribute.name.startsWith('data-gtm-')) {
          payload[attribute.name.substring(9)] = attribute.value
        }
      }

      push('custom_click', {
        button: buttonId,
        memberId: memberId ?? '',
        organizationId: organizationId ?? '',
        organizationName: organizationName ?? '',
        ...payload,
      })
    }

    document.addEventListener('click', handleClick, {
      signal: abortController.signal,
      capture: true,
    })

    return (): void => {
      abortController.abort()
    }
  }, [push, memberId, organizationId, organizationName])
}
